export default __webpack_public_path__ + "d9b061bb5caf58e6b67261d2c7b3aac2.png";